import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { MODERNIZE_CONFLUENCE_IPM_MODAL } from '../../constants/onboarding-state/onboarding-constants';

import { getOnboardingStateGQL } from './OnboardingStatus.graphql';

export const preloadModernizeConfluenceOnboardingState = () => {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: getOnboardingStateGQL,
		variables: {
			key: [...Object.values(MODERNIZE_CONFLUENCE_IPM_MODAL)],
		},
	});
};
